import React from 'react';

import AttachDropdown from 'ui-library/attach-dropdown/AttachDropdown';
import {CustomAttachDropdownOption} from 'ui-library/attach-dropdown/AttachDropdownOption';

import {FUNCTION_ICON} from '../excess/FunctionCategory';
import {findFunctions, getFunction} from '../excess/functions';

interface FunctionSearchDropdownProps {
  cid: string;
  query: string;
  onSelect: (functionName: string | null) => void;
}

const FunctionSearchDropdown = React.forwardRef<AttachDropdown, FunctionSearchDropdownProps>(
  (props: FunctionSearchDropdownProps, ref) => (
    <AttachDropdown
      errorMessage={null}
      searching={false}
      ref={ref}
      defaultOptionSelected={true}
      noResultsMessage={`No functions match "${props.query}..."`}
      results={findFunctions(props.query).map((r) => ({
        item_id: r.name,
        name: r.name,
        // HACK: appease AttachDropdownItem type.
        item: {},
      }))}
      close={() => {
        props.onSelect(null);
      }}
      selectAttachment={(id: string, name: string) => {
        props.onSelect(name);
      }}
      query={props.query}
      getRenderOptionInfo={(result) => {
        const fn = getFunction(result.name)!;
        return {
          optionContent: (
            <CustomAttachDropdownOption
              title={result.name}
              icon={FUNCTION_ICON[fn.category!]}
              metadata={fn.shortDescription}
            />
          ),
          hoverable: true,
          clickable: true,
        };
      }}
    />
  )
);

export default FunctionSearchDropdown;
